export class Isp {

    public as: string;
    public city: string;
    public country: string;
    public countryCode: string;
    public ipType: string;
    public isp: string;
    public ip: string;
    public latitude: number;
    public longitude: number;
    public org: string;
    public region: string;
    public regionName: string;
    public timezone: string;
    public zip: string;

    constructor() {
    }
}
